
import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {PartnerContactModel} from '../../../api/model/partnerContact.model';

@Injectable({
    providedIn: 'root'
})
export class PartnerContactRepository extends AbstractRepositoryV2<PartnerContactModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('PartnerContact', serviceElementsFactory, injector);
    }
}
